
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^[789]$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
